import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import { ConfirmationModal } from 'kangarootime-ui';
import RaisedContainer from '../../../../../components/RaisedContainer';
import Header from '../CreateChannelModal/Header';
import AboutChannel from './AboutChannel';
import ArchiveChannelButton from './ArchiveChannelButton';
import LeaveChannelButton from './LeaveChannelButton';

const ChannelInformationModal = ({
  isOpen,
  onClose,
  currentCenterId,
  currentChatUserId,
  selectedChannelId,
  selectedChannel,
  ...props
}) => {
  if (!isOpen) {
    return null;
  }

  const [confirmationModalDetails, setConfirmationModalDetails] = useState({});

  const isDirectMessage = selectedChannel.directMessage;
  const canArchiveChannel = selectedChannel.createdById === currentChatUserId;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <RaisedContainer className='flex-columns' style={{ height: '100%' }}>
        <Header closeModal={onClose} />
        <div className='flex' style={{ justifyContent: 'center', padding: '15vh 2rem 2rem' }}>
          <div className='flex-columns' style={{ width: 640, maxWidth: '100%' }}>
            <AboutChannel channel={selectedChannel} />
            { !isDirectMessage &&
              <div className='flex-rows' style={{ justifyContent: 'flex-end', margin: '8px 0' }}>
                { canArchiveChannel && <ArchiveChannelButton channelId={selectedChannelId} onClick={setConfirmationModalDetails} /> }
                <LeaveChannelButton channelId={selectedChannelId} onClick={setConfirmationModalDetails} />
              </div>
            }
          </div>
        </div>
        <ConfirmationModal
          open={Object.keys(confirmationModalDetails).length > 0}
          title={confirmationModalDetails.title}
          message={confirmationModalDetails.message}
          affirmativeChoice={confirmationModalDetails.affirmativeChoice}
          negativeChoice={confirmationModalDetails.negativeChoice}
          affirmativeCallback={() => {
            confirmationModalDetails.affirmativeCallback();
            onClose();
          }}
          negativeCallback={() => setConfirmationModalDetails({})}
        />
      </RaisedContainer>
    </Modal>
  );
};

ChannelInformationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  currentCenterId: PropTypes.string,
  currentChatUserId: PropTypes.string,
  selectedChannelId: PropTypes.string.isRequired,
  selectedChannel: PropTypes.object.isRequired
};

export default ChannelInformationModal;
